import type * as Y from 'yjs';
import type { Item } from '@stageplottter/core';

/**
 * Grouping (⌘G / ⌘⇧G).
 *
 * - Stage ITEMS store their group in `item.props.groupId` (string). The core schema allows
 *   arbitrary props, so no schema change is needed and groups survive export/snapshots.
 * - FREE-FORM elements have no `props` in the core schema (and `upsert` strips unknown keys),
 *   so their membership lives in a web-owned Y.Map `freeformGroups` (elementId → groupId) in the
 *   same Y.Doc. It is added to the per-user undo scope by the session. It is not part of
 *   `BoardData`, i.e. snapshots/exports drop free-form grouping (documented gap).
 *
 * A group may mix items and free-form elements; selecting one member selects all.
 */
export const GROUP_PROP = 'groupId';
export const FREEFORM_GROUPS_MAP = 'freeformGroups';

export function groupIdOf(item: Pick<Item, 'props'>): string | undefined {
  const g = item.props[GROUP_PROP];
  return typeof g === 'string' && g !== '' ? g : undefined;
}

export function freeformGroupsMap(doc: Y.Doc): Y.Map<string> {
  return doc.getMap<string>(FREEFORM_GROUPS_MAP);
}

export function readFreeformGroups(doc: Y.Doc): Record<string, string> {
  return Object.fromEntries(freeformGroupsMap(doc).entries());
}
